import React from 'react';
import { IconProps } from '.';

export const Cancel = ({
  className,
  color,
  width,
  height,
}: IconProps) => (
  <svg
    width={width ?? '29'}
    height={height ?? '29'}
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.89152 20.9899C6.46194 21.4195 6.46194 22.116 6.89152 22.5455C7.3211 22.9751 8.01758 22.9751 8.44715 22.5455L14.6693 16.3234L20.8915 22.5455C21.3211 22.9751 22.0176 22.9751 22.4472 22.5455C22.8767 22.116 22.8767 21.4195 22.4472 20.9899L16.225 14.7677L22.4472 8.54554C22.8767 8.11597 22.8767 7.41948 22.4472 6.98991C22.0176 6.56033 21.3211 6.56033 20.8915 6.98991L14.6693 13.2121L8.44715 6.98991C8.01758 6.56033 7.3211 6.56033 6.89152 6.98991C6.46194 7.41948 6.46194 8.11597 6.89152 8.54554L13.1137 14.7677L6.89152 20.9899Z"
      fill={color || '#6B778C'}
    />
  </svg>
);
